<template>
  <div class="myOrderBox">
    <!-- 标题box -->
    <div class="myOrderBox_title">{{ title }}</div>
    <div class="summaryBox">
      <span>本年度已完成采购订单数：</span
      ><span style="color: #f89a00; margin-right: 40px">{{
        dataInfo.total
      }}</span
      ><span>本年度已完成采购金额：</span
      ><span style="color: #f89a00">{{ dataInfo.amount }}</span>
    </div>
    <!-- 主体box -->
    <div class="myOrderBox_main">
      <!-- 顶部导航栏 -->
      <div class="mainBox_nav">
        <el-select v-model="currentAccount" placeholder="请选择">
          <el-option :label="parentName" :value="parentAccount"> </el-option>
          <el-option label="全部" value=""> </el-option>
          <el-option
            v-for="item in subAccountList"
            :key="item.pcAccount"
            :label="item.name"
            :value="item.pcAccount"
          >
          </el-option>
        </el-select>
        <div>
          开票状态：
          <el-select v-model="isInvoiced" placeholder="请选择">
            <el-option
              v-for="item in invoiceStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          付款状态：
          <el-select v-model="payStatus" placeholder="请选择">
            <el-option
              v-for="item in payStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          订单时间：
          <el-date-picker
            v-model="startTime"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
            :picker-options='startDate()'
          >
          </el-date-picker>
          <el-date-picker
          style="margin-left: 10px;"
            v-model="endTime"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options='endDate()'
          >
          </el-date-picker>
        </div>
        <div>
          <el-button type="primary" @click="getList(1)"> 查询 </el-button>
          <el-button type="primary" @click="resetList()"> 重置 </el-button>
        </div>
      </div>
      <div class="searchSummary">
        <span>订单数：</span
        ><span style="color: #f89a00; margin-right: 40px">{{ total }}</span
        ><span>订单金额：</span><span style="color: #f89a00">{{ amount }}</span>
      </div>
      <!-- 表头 -->
      <div class="mainBox_titleBox">
        <div style="width: 280px">订单详情</div>
        <div style="width: 204px">订单状态</div>
        <div style="width: 145px">开票状态</div>
        <div style="width: 145px">支付状态</div>

        <div style="width: 150px">订单金额</div>
        <div style="width: 150px">操作</div>
      </div>
      <!-- 无数据替代 -->
      <el-empty description="暂无数据" v-if="orderList.length == 0"></el-empty>
      <!-- 订单列表 -->
      <div
        class="mainBox_orderList"
        v-for="(item, index) in orderList"
        :key="index"
      >
        <div class="orderList_main">
          <div class="orderList_mainTitle">
            <span>{{ getDate(item.createTime) }}</span
            ><span>订单编号：{{ item.ordersn }}</span>
          </div>

          <span style="width: 204px" class="mainSpan">{{
            item.status == 3 ? "已完成" : "未完成"
          }}</span>
          <div style="width: 145px; text-align: center">
            {{ item.isInvoiced == 1 ? "已开票" : "未开票" }}
          </div>
          <div style="width: 145px">
            {{ item.payStatus == 2 ? "已支付" : "未支付" }}
          </div>
          <div class="orderPrice_text">
            <span style="color: #ff4019; font-size: 16px"
              >￥<span style="font-size: 21px">{{
                item.price.toFixed(2)
              }}</span></span
            >
            <!-- <span>在线支付</span> -->
          </div>
          <div class="btnBox" @click.stop="nothing()">
            <el-link
              :underline="false"
              type="primary"
              style="font-size: 12px"
              @click.stop="gotoDetails(item.id)"
              >订单详情</el-link
            >
          </div>
        </div>
      </div>
      <!-- 底部分页 -->
      <div class="pagination">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="current"
          layout=" prev, pager, next,total, jumper"
          :total="total"
          :page-size="limit"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { doGet } from "../../common/HttpHelper.js";
import { httpConfig } from "../../common/config.js";
export default {
  props: {
    title: String,
    required: true,
  },
  data() {
    return {
      parentAccount: this.$cookies.get("userInfo")
        ? this.$cookies.get("userInfo").pcAccount
        : "",
      parentName: this.$cookies.get("userInfo")
        ? this.$cookies.get("userInfo").name
        : "",
      subAccountList: [],
      currentAccount: this.$cookies.get("userInfo")
        ? this.$cookies.get("userInfo").pcAccount
        : "",
      isInvoiced: "",
      payStatus: "",
      startTime:'',
      endTime:'',
      invoiceStatusList: [
        { label: "全部", value: "" },
        { label: "未开票", value: 0 },
        { label: "已开票", value: 1 },
      ],
      payStatusList: [
        { label: "全部", value: "" },
        { label: "未付款", value: 0 },
        { label: "已付款", value: 1 },
      ],
      value: "",

      current: 1, //当前页数
      total: 0, //总条数
      amount: 0, //订单金额
      limit: 8, //每页显示几条
      orderList: [], //订单列表
      dataInfo: "",
      dateRange: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
    };
  },
  mounted() {
    this.getList(1); //获取订单列表
    this.getSubAccount();
    this.getTotalInfo();
  },
  methods: {
      // 日期选择约束
    startDate() {
      const that = this
      return {
        disabledDate(time) {
          if (that.endTime) {
            //如果结束时间不为空，则小于结束时间
            return (
              new Date(that.endTime).getTime() < time.getTime()
            )
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        }
      }
    },
    endDate() {
      const that = this
      console.log(1)
      return {
        disabledDate(time) {
          if (that.startTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              (new Date(that.startTime).getTime() - 86400000) > time.getTime()
            )
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        }
      }
    },
    /**
     * 时间格式化（补0）
     */
    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    /**
     * 时间戳转换
     */
    getDate(time) {
      if (!time) return "";
      if (time == typeof string) {
        var reg = getRegExp("-", "g"); // 获取正则表达式，全局替换
        time = time.replace(reg, "/");
      }
      var date = new Date(time);
      var M = date.getMonth() + 1;
      var y = date.getFullYear();
      var d = date.getDate();
      var h = date.getHours();
      var mm = date.getMinutes();
      var s = date.getSeconds();
      if (M < 10) M = "0" + M;
      if (d < 10) d = "0" + d;
      return (
        y +
        "." +
        M +
        "." +
        d +
        " " +
        this.add0(h) +
        ":" +
        this.add0(mm) +
        ":" +
        this.add0(s)
      );
    },
    /**
     * 获取数据汇总信息
     */
    getTotalInfo() {
      var that = this;
      doGet(
        httpConfig.dataSummary.getTotalInfoUrl,
        {  },
        function (res) {
          that.dataInfo = res;
        },
        function (res) {}
      );
    },
    /**
     * 查询子账号
     */
    getSubAccount() {
      var that = this;
      doGet(
        httpConfig.subAccount.getSubAccountUrl,
        { parentAccount: this.parentAccount },
        function (res) {
          that.subAccountList = res.data;
        },
        function (res) {}
      );
    },
    /**
     * 获取订单列表
     */
    getList(val) {
      if(this.startTime&&!this.endTime){
        this.$message({
          message: "请选择结束日期",
          type: "warning",
        });
        return
      }
      if(!this.startTime&&this.endTime){
        this.$message({
          message: "请选择开始日期",
          type: "warning",
        });
      }
      var data = {
        current: val,
        limit: this.limit,
        currentAccount: this.currentAccount,
        isInvoiced: this.isInvoiced,
        payStatus: this.payStatus,
        startTime: this.startTime,
        endTime: this.endTime,
      };
      var that = this;
      doGet(
        httpConfig.dataSummary.getListUrl,
        data,
        function (res) {
          that.orderList = JSON.parse(JSON.stringify(res.rows));
          that.total = res.total;
          that.amount = res.amount ? res.amount : 0;
          that.current = val;
        },
        function (res) {}
      );
    },
    resetList() {
      this.currentAccount = this.$cookies.get("userInfo")
        ? this.$cookies.get("userInfo").pcAccount
        : "";
      this.isInvoiced = "";
      this.payStatus = "";
      this.startTime = '';
      this.endTime = '';
      this.getList(1);
    },
    /**
     * 切换分页
     */
    handleCurrentChange(val) {
      //返回顶部
      this.getList(val);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    /**
     * 订单详情
     */
    gotoDetails(id) {
      this.$router.push({ path: "/orderDetails", query: { id: id } });
    },
    /**
     * 无效事件
     */
    nothing() {},
  },
};
</script>
<style scoped>
@import "../../../assets/css/personal/dataSummary";
</style>



// WEBPACK FOOTER //
// src/components/page/personal/dataSummary.vue